import axios from "axios";
import { createBrowserHistory } from "history";
import { persistor } from "../../..";
import { config } from "../../../config/appConfig";
import { getLocalStorageUser } from "../../../services/services";
import { HARVEST_YEAR } from "../../harvestYearManagement/action";
import { PREFERENCES } from "../../preferences/action";
import { set } from "date-fns";

const history = createBrowserHistory();

export const USER = {
  login: {
    success: "USER_LOGIN_SUCCESS",
    start: "USER_LOGIN_STARTED",
    error: "USER_LOGIN_FAILED"
  },
  logout: {
    success: "USER_LOGOUT_SUCCESS"
  },
  signup: {
    verified: "USER_SIGNUP_VERIFIED",
    success: "USER_SIGNUP_SUCCESS",
    error: "USER_SIGNUP_ERROR",
    start: "USER_SIGN_UP_STARTED"
  },
  verify: {
    success: "USER_VERIFY_SUCCESS",
    error: "USER_VERIFY_ERROR"
  },
  scriptionList: {
    success: "SUBSCRIPTION_SUCCESS"
  },
  isUserEnabled: {
    success: "USER_ENABLED_SUCCESS"
  }
};

const loginSuccess = () => {
  return { type: USER.login.success };
};
export const logoutSuccess = () => {
  return { type: USER.logout.success, data: {} };
};
const signupSuccess = data => {
  return { type: USER.signup.success, data };
};
const verifySucess = user => {
  return { type: USER.verify.success, user: user };
};
const verifyError = () => {
  return { type: USER.verify.error };
};
const signupapproval = user => {
  return { type: USER.signup.verified, user: user };
};
const checkEnabled = enabled => {
  return {
    type: USER.isUserEnabled.success,
    user: enabled
  };
  // return Object.assign({}, state, {
  //   user: enabled
  // });
};

export const login = user => {
  let bodyFormData = new FormData();
  bodyFormData.append("username", user.email);
  bodyFormData.append("password", user.password);
  bodyFormData.append("grant_type", config.GRANT_TYPE);
  let url = `${config.BASE_URL}/oauth/token`;
  return function(dispatch) {
    let data = "";
    dispatch({ type: USER.login.start, data });
    axios
      .post(url, bodyFormData, {
        headers: {
          "Content-Type": config.Content_Type,
          Authorization: `Basic ${config.Authorization_Token}`
        }
      })
      .then(response => {
        getUserProfile(response.data, user.email)
          .then(async value => {
            if (value) {
              localStorage.setItem("user", JSON.stringify(response.data));
              try {
                let prefrence = {};
                const profile = await fetchUserProfileData(
                  response.data,
                  user.email
                );
                if (profile.data.roleName === "SUPER_ADMIN") {
                  let d = new Date();
                  let n = d.getFullYear();
                  prefrence = {
                    harvestYear: n
                  };
                }
                else if (profile.data.roleName === "COUNTER_PARTY") {
                  var varDate = new Date(profile.data.endDate*1000); //dd-mm-YYYY
                  var today = new Date();
                  if(!profile.data.subscriptionId || (varDate <= today)){
                    // setTimeout(()=>{
                      // history.push("/settings/counterpartybilling");
                      window.location.href = "/counterpartybillings";
                    // },1000)
                  }
                }
                else {
                  const harvestYearList = await getHarvestYears(
                    response.data,
                    profile.data.farmResponseDTO.id.toString()
                  );
                  prefrence = await getPreferences(response.data, user.email);
                  if (!prefrence) {
                    prefrence = {
                      harvestYear: harvestYearList.data[0].harvestYear
                    };
                  }
                }

                dispatch({
                  type: PREFERENCES.getPreferences.success,
                  data: prefrence
                });
                localStorage.setItem(
                  "selectedHarvestYear",
                  JSON.stringify({
                    id: prefrence.harvestYear,
                    name: prefrence.harvestYear
                  })
                );
                dispatch({
                  type: HARVEST_YEAR.selectedYear.success,
                  data: prefrence.harvestYear
                });
                dispatch(loginSuccess());
              } catch (e) {
                console.log(e);
                dispatch({ type: "SERVER_ERROR", data: "Service Unavailable" });
              }
            } else {
              dispatch({
                type: USER.isUserEnabled.success,
                data: { isEnabled: value, email: user.email }
              });
            }
            window.location.reload()
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(err => {
        let mesaage = {};
        if (err.response === undefined) {
          mesaage["error_description"] = "Service Unavailable";
          mesaage["message"] = "Service Unavailable";
          dispatch({ type: "SERVER_ERROR", data: mesaage });
        } else {
          getUserStatus(user).then(userStatus => {
            if (err.response.data.error_description === "Bad credentials") {
              mesaage["error_description"] =
                "Invalid Email/Username or Password";
              mesaage["message"] = err.response.data.error_description;
              dispatch({ type: USER.login.error, data: mesaage });
            } else if (
              userStatus.status === 200 &&
              !userStatus.data.isVerified
            ) {
              mesaage["error_description"] =
                "You haven't verified your email yet. Please verify to login.";
              mesaage["message"] =
                "You haven't verified your email yet. Please verify to login.";
              dispatch({ type: USER.login.error, data: mesaage });
            } else {
              mesaage["error_description"] =
                err.response.data.error_description === "Bad credentials"
                  ? "Invalid Email/Username or Password"
                  : userStatus.data.subscriptionEntity
                  ? "User is disabled by Super Admin"
                  : err.response.data.error_description;
              mesaage["message"] = err.response.data.error_description;
              mesaage.codeId = userStatus.data.verificationCode;
              mesaage.subscriptionEntity = userStatus.data.subscriptionEntity;
              dispatch({ type: USER.login.error, data: mesaage });
            }
          });
        }
      });
  };
};

export const handleAdminPrefrence = () => {
  return function(dispatch) {
    let d = new Date();
    let n = d.getFullYear();
    let prefrence = {
      harvestYear: n
    };
    dispatch({
      type: PREFERENCES.getPreferences.success,
      data: prefrence
    });
  };
};

const fetchUserProfileData = (data, email) => {
  let url = `${config.BASE_URL}/ntrac/user/${email}/`;
  return new Promise(async (resolve, reject) => {
    try {
      let res = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${data.token_type} ${data.access_token}`
        }
      });
      resolve(res.data);
    } catch (err) {
      reject(err.response);
    }
  });
};

export const loginPageRoles = () => {
  let url = `${config.BASE_URL}/ntrac/loginPageRoles`;
  return new Promise((resolve, reject) =>  axios
  .get(url, {
    headers: {
      "Content-Type": "application/json",
    }
  })
  .then(response => {
    resolve(response.data);
  })
  .catch(err => {
    reject(err.response);
  }));
}
const getHarvestYears = (data, farmId) => {
  let url = `${config.BASE_URL}/ntrac/harvestYear/farmId/${farmId}`;
  return new Promise((resolve, reject) =>
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${data.token_type} ${data.access_token}`
        }
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err.response);
      })
  );
};

const getPreferences = (data, email) => {
  let url = `${config.BASE_URL}/ntrac/user/preferences?username=${email}`;
  return new Promise((resolve, reject) =>
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${data.token_type} ${data.access_token}`
        }
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err.response);
      })
  );
};

export const getUserProfile = (data, email) => {
  let url = `${config.BASE_URL}/ntrac/user/${email}/`;
  return new Promise((resolve, reject) =>
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${data.token_type} ${data.access_token}`
        }
      })
      .then(response => {
        console.log(response.data.data, "------", email, "kecgefug");
        const data = response.data.data;

        if (data.enabled) {
          localStorage.setItem("userProfile", JSON.stringify(data));
          resolve(true);
        }
        // else {
        //   //Redirect here to subscription page and pass the EMAIL ID  of the user.
        //   console.log('Redirecting.......')
        //   dispatch({ type: USER.isUserEnabled.success, data: data.enabled, email: email })
        // }
        resolve(false);
      })
      .catch(err => {
        reject(err);
      })
  );
};

export const logout = () => {
  return function(dispatch) {
    localStorage.removeItem("user");
    localStorage.removeItem("userProfile");
    localStorage.removeItem("currentFieldGrpId");
    localStorage.removeItem("selectedHarvestYear");
    persistor.purge(() => dispatch(logoutSuccess()));
    history.push("/login");
  };
};

const getUserStatus = user => {
  let url = `${config.BASE_URL}/ntrac/user/verificationDetails/${user.email}/`;
  return axios
    .get(url, {})
    .then(response => {
      return response.data;
    })
    .catch(err => {
      return { data: { isVerified: true, status: err.status } };
    });
};

export const isuserexist = user => {
  let url = `${config.BASE_URL}/ntrac/user/isregistered/${user.username}/`;
  return axios
    .get(url, {})
    .then(response => {
      return response.data.data.exists;
    })
    .catch(err => {
      console.log(err);
      return true;
    });
};

export const userRegister = user => {
  let url = `${config.BASE_URL}/ntrac/user/signup`;
  user.role = "ACCOUNT_OWNER";
  return function(dispatch) {
    let data = "";
    dispatch({ type: USER.signup.start, data });
    isuserexist(user)
      .then(value => {
        if (!value) {
          axios
            .post(url, user, {
              headers: {
                "Content-Type": "application/json"
              }
            })
            .then(response => {
              dispatch(signupSuccess(true));
              // dispatch({ type: "SERVER_SUCCESS", data: response.data });
            })
            .catch(err => {
              err => dispatch({ type: "LOAD_DATA_FAILURE", err });
            });
        } else {
          let data = "User Already Exist";
          dispatch({ type: USER.signup.error, data });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const CounterPartySignUpRegister = user => {
  let url = `${config.BASE_URL}/ntrac/counterparty/signup`;
  return function(dispatch) {
    let data = "";
    dispatch({ type: USER.signup.start, data });
    isuserexist(user)
      .then(value => {
        if (!value) {
          axios
            .post(url, user, {
              headers: {
                "Content-Type": "application/json"
              }
            })
            .then(response => {
              dispatch(signupSuccess(true));
              //dispatch({ type: "SERVER_SUCCESS", data: response.data });
            })
            .catch(err => {
              dispatch({ type: "LOAD_DATA_FAILURE", err });
            });
        } else {
          let data = "User Already Exist";
          dispatch({ type: USER.signup.error, data });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
};
export const TrucklineSignupRegister = user => {
  let url = `${config.BASE_URL}/ntrac/counterparty/signup`;
  return function(dispatch) {
    let data = "";
    dispatch({ type: USER.signup.start, data });
    isuserexist(user)
      .then(value => {
        if (!value) {
          axios
            .post(url, user, {
              headers: {
                "Content-Type": "application/json"
              }
            })
            .then(response => {
              dispatch(signupSuccess(true));
              //dispatch({ type: "SERVER_SUCCESS", data: response.data });
            })
            .catch(err => {
              dispatch({ type: "LOAD_DATA_FAILURE", err });
            });
        } else {
          let data = "User Already Exist";
          dispatch({ type: USER.signup.error, data });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
};


export const userRegisterBySuperAdmin = user => {
  const userDetail = getLocalStorageUser();
  let url = `${config.BASE_URL}/ntrac/user/signup`;
  user.role = "ACCOUNT_OWNER";
  return function(dispatch) {
    let data = "";
    dispatch({ type: USER.signup.start, data });
    isuserexist(user)
      .then(value => {
        if (!value) {
          axios
            .post(url, user, {
              headers: {
                "Content-Type": "application/json",
                Authorization: `${userDetail.token_type} ${userDetail.access_token}`
              }
            })
            .then(response => {
              dispatch(signupSuccess(true));
              //dispatch({ type: "SERVER_SUCCESS", data: response.data });
            })
            .catch(err => {
              err => dispatch({ type: "LOAD_DATA_FAILURE", err });
            });
        } else {
          let data = "User Already Exist";
          dispatch({ type: USER.signup.error, data });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };
};

export const verify = () => {
  return function(dispatch) {
    const user = localStorage.getItem("user");
    if (user) {
      dispatch(verifySucess(), JSON.parse(user));
    }
    dispatch(verifyError());
  };
};

export const handleNavbar = isOpen => {
  return function(dispatch) {
    dispatch({ type: "HANDLE_DRAWER", data: isOpen });
  };
};



// WEBPACK FOOTER //
// ./src/modules/user/redux/action.js